export type ChevronDirection = 'top' | 'right' | 'bottom' | 'left'

interface ChevronProps {
  direction: ChevronDirection
  className?: string
}

const getChevronRotation = (direction: ChevronDirection) => {
  switch (direction) {
    case 'right':
      return 0

    case 'top':
      return 270

    case 'bottom':
      return 90

    case 'left':
      return 180
  }
}

const ChevronIcon = ({ direction, className }: ChevronProps) => {
  const rotation = getChevronRotation(direction)
  const transform = rotation > 0 ? `rotate(${rotation} 256,256)` : undefined

  return (
    <svg viewBox="0 0 512 512" className={className}>
      <path
        d="m156,512l0,0l-56,-56l200,-200l-200,-200l56,-56l256,256l-256,256l0,0z"
        transform={transform}
        fill="currentColor"
      />
    </svg>
  )
}

export default ChevronIcon
